import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/Login'));
const Logout = React.lazy(() => import('./views/Logout'));
const InformacaoAcesso = React.lazy(() => import('./views/NovaCredencialDadosAcesso'));
const InformacoesPessoais = React.lazy(() => import('./views/NovaCredencialDadosPessoais'));
const InformacaoDeMoradia = React.lazy(() => import('./views/NovaCredencialEndereco'));
const InformacaoProfissional = React.lazy(() => import('./views/NovaCrendencialDadosProfissional'));
const DocumentosPessoais = React.lazy(() => import('./views/NovaCredencialDocumentos'));
const CadastroEfetuado = React.lazy(() => import('./views/NovaCredencialCadastroEfetuado'));
const ValidarEmail = React.lazy(() => import('./views/NovaCredencialValidarEmail'));
const EsqueceuSenha = React.lazy(() => import('./views/NovaCredencialEsqueceuSenha'));
const CadastroNovaSenha = React.lazy(() => import('./views/NovaCredencialNovaSenha'));
const ModalInserirCodigo = React.lazy(() => import('./views/NovaCredencialModalInserirCodigoEmail'))



const App = () => {
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
          <Route path="/logout" name="Logout Page" render={props => <Logout {...props} />} />
          <Route path="/dados-de-acesso/:userparams?" name="Dados de Acesso" render={props => <InformacaoAcesso {...props} />} />
          <Route path="/cadastro-efetuado/:email" name="Cadastro efetuado" render={props => <CadastroEfetuado {...props} />} />
          <Route path="/validar-email/:usuarioGuid/:codigo" name="Validar email" render={props => <ValidarEmail {...props} />} />
          <Route path="/esquecisenha" name="Esqueceu senha" render={props => <EsqueceuSenha {...props} />} />
          <Route path="/novasenha/" name="Cadastro Nova Senha" render={props => <CadastroNovaSenha {...props} />} />
          <Route path="/modalinserircodigo" name="Cadastro Nova Senha" render={props => <ModalInserirCodigo {...props} />} />
          <Route path="/" name="Home" render={props => <TheLayout {...props} />} />

        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
